import { compose } from 'redux';

import { GlobalLoader } from 'modules/common/components';
import { withOrderBookRoute } from 'modules/v2/editor/containers';

const OrderBook = () => <GlobalLoader />;

export default compose(withOrderBookRoute)(OrderBook);
